import { handleActions } from 'redux-actions';
import {
  AdvisorDetailsProps,
  AdvisorsState,
  DashboardProps,
  ListAdvisorsDataProps,
} from './interfaces';
import Types from './types';

const initialState: AdvisorsState = {
  advisorDetails: null,
  listAdvisors: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  dashboard: null,
  isLoadingDashboard: false,
  isLoading: false,
};

export default handleActions(
  {
    [Types.GET_ALL_ADVISORS_REQUEST]: (state: AdvisorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_ADVISORS_FULFILLED]: (
      state: AdvisorsState,
      { payload }: { payload: ListAdvisorsDataProps }
    ) => ({
      ...state,
      isLoading: false,
      listAdvisors: payload,
    }),
    [Types.GET_ALL_ADVISORS_REJECTED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ADVISOR_REQUEST]: (state: AdvisorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ADVISOR_FULFILLED]: (
      state: AdvisorsState,
      { payload }: { payload: AdvisorDetailsProps }
    ) => ({
      ...state,
      isLoading: false,
      advisorDetails: payload,
    }),
    [Types.GET_ADVISOR_REJECTED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.APPLY_ADVISOR_REQUEST]: (state: AdvisorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.APPLY_ADVISOR_FULFILLED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.APPLY_ADVISOR_REJECTED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.IGNORE_ADVISOR_REQUEST]: (state: AdvisorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.IGNORE_ADVISOR_FULFILLED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.IGNORE_ADVISOR_REJECTED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.APPLY_ADVISOR_REQUEST]: (state: AdvisorsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.APPLY_ADVISOR_FULFILLED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.APPLY_ADVISOR_REJECTED]: (state: AdvisorsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_DASHBOARD_REQUEST]: (state: AdvisorsState) => ({
      ...state,
      isLoadingDashboard: true,
    }),
    [Types.GET_DASHBOARD_FULFILLED]: (
      state: AdvisorsState,
      { payload }: { payload: DashboardProps }
    ) => ({
      ...state,
      isLoadingDashboard: false,
      dashboard: payload,
    }),
    [Types.GET_DASHBOARD_REJECTED]: (state: AdvisorsState) => ({
      ...state,
      isLoadingDashboard: false,
    }),
  },
  initialState
);
